module.exports = __webpack_public_path__ + "static/12-2-9f922f1ce9cfd556078c99ec2f15fc85.jpg";